import { isMockEnabled } from "@/lib/mock-flags";
import * as mock from "../mocks/fixtures";
import * as real from "./real";
import type { ListMyPaymentsParams, MyEntitlement, MySubscription, PagedPayments } from "../mocks/fixtures";

function pick() {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- isMockEnabled reads env, not a hook
  return isMockEnabled("subscription") ? mock : real;
}

export function getMySubscription(): Promise<MySubscription> {
  return pick().getMySubscription();
}

export function getMyEntitlement(): Promise<MyEntitlement> {
  return pick().getMyEntitlement();
}

export function listMyPayments(params?: ListMyPaymentsParams): Promise<PagedPayments> {
  return pick().listMyPayments(params);
}

export function cancelMySubscription(reason?: string): Promise<void> {
  return pick().cancelMySubscription(reason);
}

export function payInvoiceWithCard(invoiceId: string, returnUrl?: string) {
  return pick().payInvoiceWithCard(invoiceId, returnUrl);
}

export function changePaymentMethod(returnUrl?: string) {
  return pick().changePaymentMethod(returnUrl);
}

export function payInvoiceWithPix(invoiceId: string) {
  return pick().payInvoiceWithPix(invoiceId);
}

export function getInvoicePaymentStatus(gatewayChargeId: string) {
  return pick().getInvoicePaymentStatus(gatewayChargeId);
}

export type {
  BillingCycle,
  CardDetails,
  InvoiceCardCheckout,
  InvoicePixCharge,
  InvoicePaymentStatus,
  BoletoDetails,
  PixDetails,
  DefaultPaymentMethod,
  DerivedPaymentStatus,
  ListMyPaymentsParams,
  MyPayment,
  MySubscription,
  MySubscriptionPlan,
  NextInvoice,
  PagedPayments,
  PaymentMethod,
  PaymentStatus,
  PaymentStatusFilter,
  SubscriptionGrant,
  SubscriptionOrigin,
  SubscriptionStatus,
} from "../mocks/fixtures";

export { deriveStatus } from "../mocks/fixtures";
